import { useEffect } from "react";
import "./index.css";
import "@fontsource/raleway";
import "@fontsource/unbounded";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import {
  LoginScreen,
  ForgetPassword,
  OtpVerification,
  ResetPassword,
  UserRoleTypeScreen,
  RegisterScreen,
  Home,
  CategoryScreen,
  SubCategory,
  Uploadfile,
  Profile,
  Status,
  ProjectDetailsPage,
  // BillingAddress,
} from "./pages/index";
import { useAuth } from "./context/authContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { onMessageListener } from "./notification/onMessageListener";
import Swal from "sweetalert2";
import { useQueryClient } from "@tanstack/react-query";
function App() {
  const { isLoggedIn } = useAuth();
  const queryClient = useQueryClient();
  useEffect(() => {
    const startListening = () => {
      onMessageListener()
        .then((payload) => {
          queryClient.invalidateQueries(["projectStatus"]);
          const pathname = window.location.pathname;
          // Match something like /project-details/123
          const match = /^\/project-details\/[^/]+$/.test(pathname);
          if (match) {
            queryClient.invalidateQueries(["singleProjectList"]);
          }
          console.log("payload: onMessageListener >>>>", payload);
          const isSuccess = payload.notification?.body
            .toLowerCase()
            .includes("report is ready");
          Swal.fire({
            title: payload.notification?.title || "Notification",
            text: payload.notification?.body || "You have a new message!",
            icon: isSuccess ? "success" : "error",
            position: "top-end",
            timer: 5000,
            showCloseButton: true,
            showConfirmButton: false,
            timerProgressBar: true,
            toast: true,
            customClass: {
              popup: "my-toast-notification",
            },
          });
          startListening();
        })
        .catch((err) => console.error("Failed onMessageListener: ", err));
    };
    startListening();
  }, []);
  return (
    <div>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={isLoggedIn ? <Navigate to="/" /> : <LoginScreen />}
          />
          <Route
            path="/forgetPassword"
            element={isLoggedIn ? <Navigate to="/" /> : <ForgetPassword />}
          />
          <Route
            path="/OtpVerification"
            element={isLoggedIn ? <Navigate to="/" /> : <OtpVerification />}
          />
          <Route
            path="/resetPassword"
            element={isLoggedIn ? <Navigate to="/" /> : <ResetPassword />}
          />
          <Route
            path="/selectUserType"
            element={isLoggedIn ? <Navigate to="/" /> : <UserRoleTypeScreen />}
          />
          <Route
            path="/register"
            element={isLoggedIn ? <Navigate to="/" /> : <RegisterScreen />}
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service/category"
            element={
              <ProtectedRoute>
                <CategoryScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service/category/subcategory"
            element={
              <ProtectedRoute>
                <SubCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/service/category/subcategory/uploadfile"
            element={
              <ProtectedRoute>
                <Uploadfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/status"
            element={
              <ProtectedRoute>
                <Status />
              </ProtectedRoute>
            }
          />
          <Route
            path="/project-details/:projectId"
            element={
              <ProtectedRoute>
                <ProjectDetailsPage />
              </ProtectedRoute>
            }
          />
          {/* <Route path='/paymentMethod' element={isLoggedIn ? <Navigate to="/" /> : <PaymentMethod />} /> */}
          {/* <Route
            path="/billingAddress"
            element={isLoggedIn ? <Navigate to="/" /> : <BillingAddress />}
          /> */}
          {/* <Route path='/verificationCode' element={isLoggedIn ? <Navigate to="/" /> : <VerificationCode />} /> */}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
